"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedColumn = FeaturedColumn;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _icon = require("@site/pattern-library-utils/icon");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const FirstColWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FirstColWrapper",
  class: "pl-fp4co5w"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-icx22w1"
});
const ColumnWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ColumnWrapper",
  class: "pl-ci33vh2"
});

/**
 * Featured Column
 *
 * @param {Object} props React props
 * @param {Boolean} props.expanded Collapse Function
 * @param {String} props.text Featured Column Text
 * @param {Boolean} props.hasDescription Description Check
 * @returns {React.ReactElement} component
 * @public
 */

function FeaturedColumn({
  expanded,
  text: textProp,
  hasDescription
}) {
  return /*#__PURE__*/_react.default.createElement(FirstColWrapper, {
    "data-cy": "row-title",
    className: "first-column"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: textProp,
    "data-cy": "paragraph"
  }), hasDescription && /*#__PURE__*/_react.default.createElement(IconWrapper, null, expanded ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-up"
  }) : /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down",
    fill: _intents.default.ux.controlVoid.foregroundColor
  })));
}
FeaturedColumn.propTypes = {
  expanded: _propTypes.default.bool,
  text: _propTypes.default.string,
  hasDescription: _propTypes.default.bool
};

/**
 * BodyColumn Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Link Trancking name
 * @param {Boolean} props.checked Column Checkmark Condition
 * @param {String} props.text Column Text
 * @param {String} props.link Column Link
 * @returns {React.ReactElement} BodyColumn Component
 * @public
 */

function BodyColumn({
  _name,
  checked = false,
  text: textProp,
  link
}) {
  function stopPropagation(e) {
    e.stopPropagation();
  }
  return /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    "data-cy": "body-column"
  }, checked && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark",
    width: "20",
    height: "20"
  }), textProp && !link && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: textProp
  }), link && /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: link,
    rel: "noreferrer",
    target: "_blank",
    "aria-label": textProp,
    onClick: stopPropagation,
    onKeyPress: e => {
      if (e.key === 'Enter') {
        e.stopPropagation();
      }
    }
  }, _patternLibraryUtils.tracking.create(`${_name ? `${_name} ${textProp}` : textProp}`, true, false)), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1
  }, textProp)), !checked && !textProp && !link && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "minus",
    width: "20",
    height: "20",
    fill: _intents.default.ux.controlVoid.foregroundColor
  }));
}
var _default = exports.default = BodyColumn;
BodyColumn.propTypes = {
  _name: _propTypes.default.string,
  checked: _propTypes.default.bool,
  text: _propTypes.default.string,
  link: _propTypes.default.string
};